import axios from 'axios';
import PreguntaFrecuenteTabla from '../types/PreguntaFrecuenteTabla';

async function InsertarPreguntaFrecuente(PreguntaFrecuenteNueva: PreguntaFrecuenteTabla) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/insertar_preguntafrecuente"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "preguntafrecuente": [
                {
                    "pregunta": PreguntaFrecuenteNueva.pregunta,
                    "respuesta": PreguntaFrecuenteNueva.respuesta,
                    "habilitado": PreguntaFrecuenteNueva.habilitado,
                    "orden": PreguntaFrecuenteNueva.orden
                }
            ]
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default InsertarPreguntaFrecuente;